import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  withStyles,
  IconButton,
  Menu,
  MenuItem,
  ListItemText,
  ListItemIcon,
  Divider,
  ListSubheader,
} from '@material-ui/core'
import { Add, MoreVert, Delete, Cancel, Done, Edit } from '@material-ui/icons'
import Button from 'components/theme/Button'
import {
  addOrEditEventGoal,
  addEventGoalToCampaign,
  removeEventGoal,
  removeNewEventGoal,
  selectEventGoal,
  changeSubentity,
  changeSubentityValue,
  changeOperator,
  changeEntity,
  addSubcriteria,
  removeSubcriteria,
  changeCustomField,
} from 'actions/campaign/addOrEdit'
import { createOrUpdateCampaign } from 'actions/campaign'
import EventGoalSelect from './EventGoalSelect'
import EntitySelect from './Select'
import EntityTypeIcon from 'utils/EntityTypeIcon'
import entityTypeColloquialMap from 'utils/entityTypeColloquialMap'
import {
  reduce,
  capitalize,
  difference,
  intersection,
  upperFirst,
  lowerCase,
} from 'lodash'
import formatNumber from 'utils/formatNumber'
import language from 'utils/vast-languagepack'
import entityTypeIconMap from 'utils/entityTypeIconMap'
import { read } from 'actions/data'
import currentNumberOfAllowedEventGoals from 'utils/currentNumberOfAllowedEventGoals'
import { toggleGroupDialog } from 'actions/contacts/groups'
import { trueEventOptionFunc } from 'utils/EventGoalUtils'

export default connect(
  (state, { stageIdx }) => {
    const users = state.data?.user

    return {
      event_goals:
        state.campaign.addOrEdit.campaign?.stages?.[stageIdx]?.event_goals,
      newEventGoal: state.campaign.addOrEdit.newEventGoal,
      eventgoaloptions: state.data.eventgoaloption,
      tasks: state.tasks.tasksByID,
      contactgroups: state.contacts.groupsByID,
      signupforms: state.signupForm.forms,
      tasksLoaded: state.loadStatus.tasks,
      signupformsLoaded: state.loadStatus.forms,
      contactgroupsLoaded: state.loadStatus.groups,
      status: state.campaign.addOrEdit.campaign.status,
      tasksIDsInCampaignCalendar: state.campaign.addOrEdit.campaign?.calendar,
      customforms: state.data?.customform,
      entityIDSelected: state.campaign.addOrEdit.subentityOptions.entity,
      subentity: state.campaign.addOrEdit.subentityOptions.subentity,
      subentity_value:
        state.campaign.addOrEdit.subentityOptions.subentity_value,
      subcriteria: state.campaign.addOrEdit.subentityOptions.subcriteria,
      operator: state.campaign.addOrEdit.subentityOptions.operator,
      isCustomField: state.campaign.addOrEdit.subentityOptions.isCustomField,
      customFieldName: state.campaign.addOrEdit.subentityOptions.customFieldName,
      customAttributes: state.contacts.customAttributes,
      twilionumbers: Object.values(state.data?.phonenumbers || {}).reduce(
        (acc, el) => {
          acc[el.phone_number] = {
            ...el,
            id: el.phone_number,
            name: `${el.phone_number}${
              el.vast_user_name
                ? ' - ' +
                  users?.[el.vast_user_name]?.first_name +
                  ' ' +
                  users?.[el.vast_user_name]?.last_name
                : ''
            }`,
          }
          return acc
        },
        {},
      ),
      vastusers: Object.values(users || {}).reduce((acc, el) => {
        acc[el.user_name] = {
          ...el,
          id: el.user_name,
          name: `${el.first_name || ''} ${el.last_name || ''}`,
        }
        return acc
      }, {}),
    }
  },
  dispatch =>
    bindActionCreators(
      {
        addOrEditEventGoal,
        addEventGoalToCampaign,
        createOrUpdateCampaign,
        removeEventGoal,
        removeNewEventGoal,
        selectEventGoal,
        changeSubentity,
        changeSubentityValue,
        changeOperator,
        changeEntity,
        read,
        toggleGroupDialog,
        addSubcriteria,
        removeSubcriteria,
        changeCustomField,
      },
      dispatch,
    ),
)(
  withStyles(theme => ({
    addButton: {
      position: 'absolute',
      top: 8,
      right: 40,
      [theme.breakpoints.down('sm')]: {
        fontSize: 12,
        top: 10,
        right: 12,
      },
    },
    addIcon: {
      [theme.breakpoints.down('sm')]: {
        fontSize: 12,
      },
    },
    eventGoal: {
      backgroundColor: '#e1ecb1',
      borderRadius: 20,
      border: '2px solid #487648',
      minHeight: 67,
      marginBottom: 10,
      padding: '10px 55px 10px 70px',
      position: 'relative',
      marginTop: 10,
      display: 'table',
      width: '100%',
    },
    number: {
      marginRight: 3,
      fontSize: theme.typography.pxToRem(22),
    },
    stat: {
      fontWeight: 'bold',
      color: '#487648',
      marginRight: 17,
    },
    text: {
      fontSize: theme.typography.pxToRem(9),
      display: 'inline-block',
    },
    dragIndicator: {
      position: 'absolute',
      top: 19,
      left: 7,
      cursor: 'grab',
      fill: 'rgba(0, 0, 0, 0.24)',
      [theme.breakpoints.down('sm')]: {
        left: 2,
        top: 22,
        fontSize: 18,
      },
    },
    entityTypeIcon: {
      fill: '#487648',
      position: 'absolute',
      left: '29px',
      top: '50%',
      transform: 'translateY(-50%)',
      width: '37px',
      height: '37px',
      [theme.breakpoints.down('sm')]: {
        left: 18,
        width: 27,
      },
    },
    name: {
      // marginLeft: 60,
      display: 'table-cell',
      verticalAlign: 'middle',
      color: '#487648',
      [theme.breakpoints.down('sm')]: {
        marginLeft: 40,
        fontSize: 14,
      },
    },
    listItemIconRoot: {
      verticalAlign: 'middle',
      marginRight: 9,
    },
    input: {
      '&:focus': {
        border: '2px solid #487648',
      },
    },
  }))(
    class EventGoals extends Component {
      state = { anchorEl: null, anchorElNew: null, anchorElAdd: null }

      // componentDidUpdate(prevProps) {
      //   if (prevProps.entityIDSelected !== this.props.entityIDSelected) {
      //     this.props.read(this.props.entityIDSelected, 'customform')
      //   }
      // }

      render() {
        const description = event_goal => {
          if (event_goal && this.props.eventgoaloptions) {
            const trueEventOption = trueEventOptionFunc(
              event_goal,
              this.props.eventgoaloptions,
            )

            const descriptionArray = trueEventOption?.description?.split('__')

            const entityIDType =
              trueEventOption?.entity_id_type &&
              trueEventOption.entity_id_type !== '"-1"'
                ? trueEventOption.entity_id_type
                : ''

            let content = descriptionArray?.[0]

            if (descriptionArray?.length > 1 && !event_goal?.subentity) {
              content = (
                <>
                  {descriptionArray[0]}
                  <strong>
                    {this.props?.[`${entityIDType}s`]?.[event_goal.entity]
                      ?.name ||
                      (entityIDType === 'twilionumber'
                        ? `any user`
                        : entityIDType)}
                  </strong>
                  {descriptionArray[1]}
                </>
              )
            }

            const stringOperatorMap = {
              '==': 'that exactly matches ',
              '!=': 'that does not exactly match ',
              bw: 'that begins with ',
              '!bw': 'that does not begin with ',
              ew: 'that ends with ',
              '!ew': 'that does not end with ',
              co: 'that contains ',
              '!co': 'that does not contain ',
            }

            const numericOperatorMap = {
              eq: 'that equals ',
              ne: 'that does not equal ',
              lt: 'that is less than ',
              gt: 'that is greater than ',
              le: 'that is less than or equal to ',
              ge: 'that is greater than or equal to ',
            }

            const operatorMap = { ...stringOperatorMap, ...numericOperatorMap }

            const quote = numericOperatorMap[event_goal?.operator] ? null : '"'

            if (
              event_goal.event_type ===
                'event.custom.submit.contact' /* || event_goal.event_type === 'api.crud.update.contact' */ &&
              event_goal?.subentity
            ) {
              const section = this.props?.customforms?.[
                event_goal.entity
              ]?.form?.sections?.find?.(
                section =>
                  section?.field?.field_name === event_goal.subentity ||
                  section?.contactfield?.field_name === event_goal.subentity,
              )

              content = (
                <>
                  {descriptionArray[0]}
                  <strong>
                    {this.props?.customforms?.[event_goal.entity]?.name ||
                      entityIDType}
                  </strong>
                  {section?.contactfield ? ' field ' : descriptionArray[1]}
                  <strong>
                    {section?.label ||
                      (section?.field?.field_name ||
                      section?.contactfield?.field_name
                        ? upperFirst(
                            lowerCase(
                              section.field.field_name ||
                                section?.contactfield?.field_name,
                            ),
                          )
                        : event_goal.subentity)}
                  </strong>
                  {event_goal?.subentity_value && (
                    <>
                      {descriptionArray[2]}
                      {event_goal?.operator && event_goal?.operator !== '=='
                        ? operatorMap?.[event_goal?.operator]
                        : null}
                      {quote}
                      <strong>{event_goal.subentity_value}</strong>
                      {quote}
                    </>
                  )}
                </>
              )
            }

            if (
              event_goal?.subentity &&
              event_goal.event_type?.slice?.(0, 3) === 'api'
            ) {
              const defaultProperties = {
                first_name: true,
                middle_name: true,
                last_name: true,
                location: true,
                notes: true,
              }

              content = (
                <>
                  {descriptionArray[0]}
                  <strong>
                    {defaultProperties?.[event_goal?.subentity]
                      ? upperFirst(lowerCase(event_goal.subentity))
                      : event_goal.subentity}
                  </strong>
                  {descriptionArray[1]}
                  {(event_goal.event_type === 'api.crud.insert.contact' ||
                    event_goal.event_type === 'api.crud.update.contact') &&
                  event_goal?.operator &&
                  event_goal?.operator !== '=='
                    ? operatorMap?.[event_goal?.operator]
                    : null}
                  {quote}
                  <strong>{event_goal?.subentity_value}</strong>
                  {quote}
                </>
              )
            }

            if (
              event_goal.event_type === 'event.sms.twilio.inbound' &&
              event_goal?.subentity_value
            ) {
              content = (
                <>
                  {descriptionArray[0]}
                  <strong>{event_goal?.entity}</strong>
                  {descriptionArray[1]}
                  {event_goal?.operator
                    ? operatorMap[event_goal?.operator]
                    : null}
                  {quote}
                  <strong>{event_goal?.subentity_value}</strong>
                  {quote}
                </>
              )
            }

            return (
              <div>
                <span>{content}</span>
              </div>
            )
          }

          return null
        }

        const entityOptionIDs =
          this.props.newEventGoal &&
          this.props.newEventGoal.event_type &&
          this.props.eventgoaloptions?.[this.props.newEventGoal.id] &&
          this.props.newEventGoal.entity_id_type &&
          this.props.newEventGoal.entity_id_type !== '"-1"'
            ? Object.keys(
                this.props.eventgoaloptions?.[this.props.newEventGoal.id]
                  ?.entity_id_type === 'task'
                  ? this.props.eventgoaloptions?.[this.props.newEventGoal.id]
                      .id === '7'
                    ? reduce(
                        this.props.tasks,
                        (smsTasks, task, id) => {
                          if (task.task_type_id === '2') smsTasks[id] = true
                          return smsTasks
                        },
                        {},
                      )
                    : reduce(
                        this.props.tasks,
                        (emailTasks, task, id) => {
                          if (task.task_type_id === '1') emailTasks[id] = true
                          return emailTasks
                        },
                        {},
                      )
                  : this.props?.[
                      `${
                        this.props.eventgoaloptions[this.props.newEventGoal.id]
                          .entity_id_type
                      }s`
                    ],
              )
            : []

        const taskIDsByTypeInCampaign = this.props.taskIDsInCampaign.length
          ? intersection(entityOptionIDs, this.props.taskIDsInCampaign)
          : []

        const tasksByTypeInCampaign = Object.keys(this.props.tasks).length
          ? taskIDsByTypeInCampaign
              .map(id => this.props.tasks[id])
              .sort(
                (a, b) => new Date(b.when_created) - new Date(a.when_created),
              )
          : []

        const groupIDsInCampaign = Object.keys(
          tasksByTypeInCampaign.reduce((tasks, task) => {
            if (task.move_contacts_btwn_groups) {
              tasks[
                task.move_contacts_btwn_groups.trigger_data.removefrom_contactgroup_id
              ] = true
              tasks[
                task.move_contacts_btwn_groups.trigger_data.addto_contactgroup_id
              ] = true
            } else if (task.remove_contacts_from_group) {
              tasks[
                task.remove_contacts_from_group.trigger_data.contactgroup_id
              ] = true
            } else if (task.add_contacts_to_group) {
              tasks[
                task.add_contacts_to_group.trigger_data.contactgroup_id
              ] = true
            }

            return tasks
          }, {}),
        )

        const groupsInCampaign = this.props.contactgroups
          ? groupIDsInCampaign
              .map(groupID => this.props.contactgroups[groupID])
              .sort((a, b) => b.contact_count - a.contact_count)
          : []

        const groupIDsNotInCampaign = difference(
          entityOptionIDs,
          groupIDsInCampaign,
        )

        const groupsNotInCampaign = this.props.contactgroups
          ? groupIDsNotInCampaign
              .map(groupID => this.props.contactgroups[groupID])
              .sort((a, b) => b.contact_count - a.contact_count)
          : []

        const taskIDsNotInCampaign =
          Object.keys(this.props.tasks).length &&
          this.props.taskIDsInCampaign.length
            ? difference(entityOptionIDs, this.props.taskIDsInCampaign)
            : entityOptionIDs

        const tasksNotInCampaign = Object.keys(this.props.tasks).length
          ? taskIDsNotInCampaign
              .map(id => this.props.tasks[id])
              .sort(
                (a, b) => new Date(b.when_created) - new Date(a.when_created),
              )
          : []

        const entityOptionMapFunc = (entities, key, id, name) =>
          entities?.map(entity => (
            <MenuItem
              key={`campaignEventGoalSelectOption${
                id ? entity?.[id] : entity.id
              }${key}`}
              value={id ? entity?.[id] : entity.id}
            >
              <ListItemIcon
                classes={{ root: this.props.classes.listItemIconRoot }}
              >
                <EntityTypeIcon
                  entityType="eventgoaloption"
                  entityID={
                    this.props.eventgoaloptions[this.props.newEventGoal.id]
                      .event_type
                  }
                  entity={entity}
                />
              </ListItemIcon>
              {name ? entity?.[name] : entity?.name}
            </MenuItem>
          ))

        const entitiesInCampaign = {
          group: groupsInCampaign,
          task: tasksByTypeInCampaign,
          form: [],
          'custom form': [],
          'phone number': [],
        }

        const entitiesNotInCampaign = {
          group: groupsNotInCampaign,
          task: tasksNotInCampaign,
          form: Object.keys(this.props.signupforms || {}).length
            ? entityOptionIDs
                .map(
                  (id, idx) =>
                    this.props.signupforms[id] || {
                      id: `blank${idx}`,
                      name: `blank${idx}`,
                    },
                )
                .sort((a, b) => {
                  const aSignups = a.signups ? a.signups.length : 0
                  const bSignups = b.signups ? b.signups.length : 0

                  if (aSignups < bSignups) {
                    return 1
                  } else if (aSignups > bSignups) {
                    return -1
                  }

                  if (new Date(a.when_created) > new Date(b.when_created)) {
                    return -1
                  } else if (
                    new Date(a.when_created) < new Date(b.when_created)
                  ) {
                    return 1
                  } else {
                    return 0
                  }
                })
            : [],
          'custom form': Object.keys(this.props.customforms || {}).length
            ? entityOptionIDs.map(
                (id, idx) =>
                  this.props.customforms[id] || {
                    id: `blank${idx}`,
                    name: `blank${idx}`,
                  },
              )
            : [],
          'phone number': Object.keys(this.props.twilionumbers || {}).length
            ? entityOptionIDs.map(
                (id, idx) =>
                  this.props.twilionumbers[id] || {
                    id: `blank${idx}`,
                    name: `blank${idx}`,
                  },
              )
            : [],
        }

        const campaignOptions =
          this.props.newEventGoal &&
          this.props.newEventGoal.event_type &&
          this.props.newEventGoal.event_type !== 'blank' &&
          this.props.newEventGoal.entity_id_type &&
          this.props.newEventGoal.entity_id_type !== '"-1"'
            ? entityOptionMapFunc(
                entitiesInCampaign[
                  entityTypeColloquialMap[
                    this.props.eventgoaloptions[this.props.newEventGoal.id]
                      .entity_id_type
                  ]
                ],
                `${
                  entityTypeColloquialMap[
                    this.props.eventgoaloptions[this.props.newEventGoal.id]
                      .entity_id_type
                  ]
                }Options`,
              )
            : []

        const restOptions =
          this.props.newEventGoal &&
          this.props.newEventGoal.event_type &&
          this.props.newEventGoal.event_type !== 'blank' &&
          this.props.newEventGoal.entity_id_type &&
          this.props.newEventGoal.entity_id_type !== '"-1"'
            ? entityOptionMapFunc(
                entitiesNotInCampaign[
                  entityTypeColloquialMap[
                    this.props.eventgoaloptions[this.props.newEventGoal.id]
                      .entity_id_type
                  ]
                ],
                `${
                  entityTypeColloquialMap[
                    this.props.eventgoaloptions[this.props.newEventGoal.id]
                      .entity_id_type
                  ]
                }Options`,
              )
            : []

        const customFormQuestionOptions = this.props?.customforms?.[
          this.props.entityIDSelected
        ]?.form?.sections
          // .filter((section) => section.type === 'field')
          .map((section, idx) => {
            // console.log(section)

            return (
              <MenuItem
                key={`campaignEventGoalSelectQuestion${
                  section?.field?.field_name || section?.label
                }`}
                value={
                  section?.field?.field_name ||
                  section?.contactfield?.field_name
                }
              >
                {section?.label ||
                  (section?.field?.field_name
                    ? upperFirst(lowerCase(section.field.field_name))
                    : `Question #${idx + 1}`)}
              </MenuItem>
            )
          })

        const contactAttributes = [
          { name: 'first_name', label: 'First name' },
          { name: 'middle_name', label: 'Middle name' },
          { name: 'last_name', label: 'Last name' },
          { name: 'phones', label: 'Phone Number' },
          { name: 'email', label: 'Email Address' },
          { name: 'location', label: 'Location' },
          { name: 'notes', label: 'Notes' },
          { name: 'vastuser', label: 'Assigned User' },
          ...(this.props?.customAttributes || []),
        ]?.filter(attribute => attribute.name)

        const contactAttributeOptions = contactAttributes?.map(attribute => (
          <MenuItem
            key={`campaignEventGoalSelectAttribute${attribute.name}`}
            value={attribute.name}
          >
            {attribute.label || attribute.name}
          </MenuItem>
        ))

        const formType =
          this.props?.customforms?.[this.props.entityIDSelected]?.internal_type

        const customFormQuestion = (subIdx, field_name) =>
          this.props?.customforms?.[
            this.props.entityIDSelected
          ]?.form?.sections?.find?.(section => {
            if (field_name) {
              return section?.field?.field_name === field_name
            }

            return typeof subIdx === 'number'
              ? section?.field?.field_name ===
                  this.props.subcriteria?.[subIdx]?.subentity
              : section?.field?.field_name === this.props.subentity
          })

        const subentityOptions =
          this.props.newEventGoal.event_type === 'event.custom.submit.contact'
            ? customFormQuestionOptions
            : contactAttributeOptions

        const userOptions = Object.values(this.props.vastusers)?.map(user => (
          <MenuItem
            key={`campaignEventGoalSelectAnswer${user.user_name}`}
            value={user.user_name}
          >
            {user.name}
          </MenuItem>
        ))

        const operatorSelector = (subIdx, defaultFieldType) => {
          const operator =
            typeof subIdx === 'number'
              ? this.props.subcriteria?.[subIdx]?.operator
              : this.props.operator

          const operators = [
            <ListSubheader disableSticky key="text-operators-header">
              Text Operators
            </ListSubheader>,
            <MenuItem value="==">Exactly matches the value below</MenuItem>,
            <MenuItem value="!=">
              Does not exactly match the value below
            </MenuItem>,
            <MenuItem value="bw">Begins with the value below</MenuItem>,
            <MenuItem value="!bw">
              Does not begin with the value below
            </MenuItem>,
            <MenuItem value="ew">Ends with the value below</MenuItem>,
            <MenuItem value="!ew">Does not end with the value below</MenuItem>,
            <MenuItem value="co">Contains the value below</MenuItem>,
            <MenuItem value="!co">Does not contain the value below</MenuItem>,
            // <MenuItem value="lt">Comes before the value below alphabetically</MenuItem>,
            // <MenuItem value="gt">Comes after the value below alphabetically</MenuItem>,
            // <MenuItem value="le">Comes before or is the same as the value below alphabetically</MenuItem>,
            // <MenuItem value="ge">Comes after or is the same as the value below alphabetically</MenuItem>,
            <ListSubheader disableSticky key="numeric-operators-header">
              Numeric Operators
            </ListSubheader>,
            <MenuItem value="eq">Equals the value below</MenuItem>,
            <MenuItem value="ne">Does not equal the value below</MenuItem>,
            <MenuItem value="lt">Is less than the value below</MenuItem>,
            <MenuItem value="gt">Is greater than the value below</MenuItem>,
            <MenuItem value="le">
              Is less than or equal to the value below
            </MenuItem>,
            <MenuItem value="ge">
              Is greater than or equal to the value below
            </MenuItem>,
          ]

          return (
            <EntitySelect
              value={operator || (defaultFieldType === 'number' ? 'eq' : '==')}
              handleChange={operator => {
                this.props.changeOperator(operator, subIdx)
              }}
              items={operators}
            />
          )
        }

        const iconButtonFunc = (subIdx, iconVal, noIconVal) => {
          const subentity =
            typeof subIdx === 'number'
              ? this.props.subcriteria?.[subIdx]?.subentity
              : this.props.subentity

          const subentity_value =
            typeof subIdx === 'number'
              ? this.props.subcriteria?.[subIdx]?.subentity_value
              : this.props.subentity_value

          const condition =
            (this.props.newEventGoal.id === '12' && subentity) ||
            subentity_value

          if (this.props.subcriteria.length) {
            if (subIdx === this.props.subcriteria.length - 1) {
              return condition ? iconVal : noIconVal
            }
            return noIconVal
          }
          return condition ? iconVal : noIconVal
        }

        const removeSubcriteriaButton = subIdx =>
          typeof subIdx === 'number' ? (
            <IconButton
              onClick={() => this.props.removeSubcriteria(subIdx)}
              style={{
                position: 'absolute',
                right: -51,
                top: '50%',
                transform: 'translate(0px, -50%)',
              }}
            >
              <Delete />
            </IconButton>
          ) : null

        const iconButton = subIdx => {
          const subentity =
            /* typeof subIdx === 'number'
              ? this.props.subcriteria?.[subIdx]?.subentity
              : */ this.props.subentity

          const subentity_value =
            /* typeof subIdx === 'number'
              ? this.props.subcriteria?.[subIdx]?.subentity_value
              : */ this.props.subentity_value || undefined

          const button =
            subentity === 'vastuser' ? (
              <div style={{ position: 'absolute', right: 0, top: -10 }}>
                <IconButton
                  onClick={() => {
                    if (subentity_value !== 'blank') {
                      Promise.resolve(
                        this.props.addEventGoalToCampaign({
                          event_goal: {
                            event_type:
                              this.props.eventgoaloptions[
                                this.props.newEventGoal.id
                              ].event_type,
                            entity: this.props.entityIDSelected || '0',
                            subentity,
                            subentity_value,
                            and_subcriteria: this.props.subcriteria.length
                              ? [
                                  { subentity, subentity_value },
                                  ...this.props.subcriteria.map(subCrt => {
                                    return {
                                      ...subCrt,
                                      subentity_value:
                                        subCrt.subentity_value || undefined,
                                    }
                                  }),
                                ]
                              : undefined,
                          },
                          index: this.props.stageIdx,
                          editIdx: this.props.newEventGoal.editIdx,
                        }),
                      ).then(() => this.props.createOrUpdateCampaign())
                    }
                  }}
                  style={{ backgroundColor: '#487648', color: '#fff' }}
                >
                  <Done />
                </IconButton>
              </div>
            ) : formType === 'ci1' ||
              customFormQuestion?.(subIdx)?.field?.type === 'text' ||
              customFormQuestion?.(subIdx)?.field?.type === 'number' ||
              this.props.newEventGoal?.event_type?.slice?.(0, 3) === 'api' ? (
              <div style={{ position: 'absolute', right: 0, top: -10 }}>
                <IconButton
                  onClick={() =>
                    Promise.resolve(
                      this.props.addEventGoalToCampaign({
                        event_goal: {
                          event_type:
                            this.props.eventgoaloptions[
                              this.props.newEventGoal.id
                            ].event_type,
                          entity: this.props.entityIDSelected || '0',
                          subentity,
                          subentity_value,
                          operator:
                            this.props.operator === '=='
                              ? undefined
                              : this.props.operator,
                          and_subcriteria: this.props.subcriteria.length
                            ? [
                                {
                                  subentity,
                                  subentity_value,
                                  operator:
                                    this.props.operator === '=='
                                      ? undefined
                                      : this.props.operator,
                                },
                                ...this.props.subcriteria.map(subCrt => {
                                  return {
                                    ...subCrt,
                                    operator:
                                      subCrt.operator === '=='
                                        ? undefined
                                        : subCrt.operator,
                                    subentity_value:
                                      subCrt.subentity_value || undefined,
                                  }
                                }),
                              ]
                            : undefined,
                        },
                        index: this.props.stageIdx,
                        editIdx: this.props.newEventGoal.editIdx,
                      }),
                    ).then(() => this.props.createOrUpdateCampaign())
                  }
                  style={{ backgroundColor: '#487648', color: '#fff' }}
                >
                  <Done />
                </IconButton>
              </div>
            ) : this.props.newEventGoal?.id === '18' ? (
              <div style={{ position: 'absolute', right: 0, top: -10 }}>
                <IconButton
                  onClick={() =>
                    Promise.resolve(
                      this.props.addEventGoalToCampaign({
                        event_goal: {
                          event_type:
                            this.props.eventgoaloptions[
                              this.props.newEventGoal.id
                            ].event_type,
                          entity: this.props.entityIDSelected || '0',
                          subentity: 'body',
                          subentity_value,
                          operator: this.props.operator,
                          and_subcriteria: this.props.subcriteria.length
                            ? [
                                {
                                  subentity: 'body',
                                  subentity_value,
                                  operator: this.props.operator,
                                },
                                ...this.props.subcriteria.map(subCrt => ({
                                  ...subCrt,
                                  subentity: 'body',
                                  operator:
                                    subCrt.operator === '=='
                                      ? undefined
                                      : subCrt.operator,
                                })),
                              ]
                            : undefined,
                        },
                        index: this.props.stageIdx,
                        editIdx: this.props.newEventGoal.editIdx,
                      }),
                    ).then(() => this.props.createOrUpdateCampaign())
                  }
                  style={{ backgroundColor: '#487648', color: '#fff' }}
                >
                  <Done />
                </IconButton>
              </div>
            ) : (
              <div style={{ position: 'absolute', right: 0, top: -10 }}>
                <IconButton
                  onClick={() => {
                    if (subentity_value !== 'blank') {
                      Promise.resolve(
                        this.props.addEventGoalToCampaign({
                          event_goal: {
                            event_type:
                              this.props.eventgoaloptions[
                                this.props.newEventGoal.id
                              ].event_type,
                            entity: this.props.entityIDSelected,
                            subentity,
                            subentity_value,
                            and_subcriteria: this.props.subcriteria.length
                              ? [
                                  {
                                    subentity,
                                    subentity_value,
                                    operator: this.props.operator,
                                  },
                                  ...this.props.subcriteria.map(subCrt => {
                                    return {
                                      ...subCrt,
                                      subentity_value:
                                        subCrt.subentity_value || undefined,
                                    }
                                  }),
                                ]
                              : undefined,
                          },
                          index: this.props.stageIdx,
                          editIdx: this.props.newEventGoal.editIdx,
                        }),
                      ).then(() => this.props.createOrUpdateCampaign())
                    }
                  }}
                  style={{ backgroundColor: '#487648', color: '#fff' }}
                >
                  <Done />
                </IconButton>
              </div>
            )

          return iconButtonFunc(subIdx, button, null)
        }

        const subentityValueComponent = subIdx => {
          if (!this.props.subentity && this.props.newEventGoal.id !== '18') {
            return null
          }

          const subentity =
            typeof subIdx === 'number'
              ? this.props.subcriteria?.[subIdx]?.subentity
              : this.props.subentity
          const subentity_value =
            typeof subIdx === 'number'
              ? this.props.subcriteria?.[subIdx]?.subentity_value
              : this.props.subentity_value

          const width = iconButtonFunc(subIdx, 'calc(100% - 50px)', '100%')
          const marginTop = iconButtonFunc(subIdx, 18, 10)

          return subentity === 'vastuser' ? (
            <div
              style={{
                position: 'relative',
                marginTop,
                marginBottom: 10,
              }}
            >
              <div style={{ width }}>
                <EntitySelect
                  value={subentity_value || 'blank'}
                  handleChange={value =>
                    this.props.changeSubentityValue(value, subIdx)
                  }
                  items={[
                    <MenuItem
                      key="campaignEventGoalSelectAnswerBlank"
                      value="blank"
                    >
                      Select a user
                    </MenuItem>,
                    ...(userOptions || []),
                  ]}
                />
              </div>
              {iconButton(subIdx)} 
            </div>
          ) : this.props.isCustomField ||
            formType === 'ci1' ||
            customFormQuestion?.(subIdx)?.field?.type === 'text' ||
            customFormQuestion?.(subIdx)?.field?.type === 'number' ||
            // The logic below needs to be re-evaluated. We may add new
            // event goals that begin with api, and this condition may never
            // be reached anyway.
            this.props.newEventGoal?.event_type?.slice?.(0, 3) === 'api' ? (
            <>
              {(this.props.newEventGoal?.id === '13' &&
                customFormQuestion?.(subIdx)?.field?.type !== 'number') ||
              this.props.newEventGoal?.id === '14' ||
              this.props.newEventGoal?.id === '15' ||
              formType === 'ci1'
                ? operatorSelector(subIdx, 'text')
                : null}
              {this.props.newEventGoal?.id === '13' &&
              customFormQuestion?.(subIdx)?.field?.type === 'number'
                ? operatorSelector(subIdx, 'number')
                : null}
              <div
                style={{
                  position: 'relative',
                  marginTop,
                  marginBottom: 10,
                }}
              >
                <input
                  placeholder={
                    this.props.newEventGoal.event_type ===
                    'event.custom.submit.contact'
                      ? 'Enter an answer for this question'
                      : 'Enter a value for this contact attribute'
                  }
                  value={subentity_value}
                  onChange={e =>
                    this.props.changeSubentityValue(e?.target?.value, subIdx)
                  }
                  style={{
                    width,
                    fontSize: 16,
                    padding: '5px 5px 5px 14px',
                    borderRadius: 24,
                  }}
                  className={this.props.classes.input}
                  type={customFormQuestion?.(subIdx)?.field?.type}
                />
                {iconButton(subIdx)}
              </div>
            </>
          ) : this.props.newEventGoal?.id === '18' ? (
            <div>
              {operatorSelector(subIdx, 'text')}
              <div
                style={{
                  position: 'relative',
                  marginTop,
                  marginBottom: 10,
                }}
              >
                <input
                  placeholder="Enter a value for the body of the incoming text message"
                  value={subentity_value}
                  onChange={e =>
                    this.props.changeSubentityValue(e?.target?.value, subIdx)
                  }
                  style={{
                    width,
                    fontSize: 16,
                    padding: '5px 5px 5px 14px',
                    borderRadius: 24,
                  }}
                  className={this.props.classes.input}
                  type={customFormQuestion?.(subIdx)?.field?.type}
                />
                {iconButton(subIdx)}
              </div>
            </div>
          ) : (
            <div style={{ position: 'relative', marginTop, marginBottom: 10 }}>
              <div style={{ width }}>
                <EntitySelect
                  value={subentity_value || 'blank'}
                  handleChange={value =>
                    this.props.changeSubentityValue(value, subIdx)
                  }
                  items={[
                    <MenuItem
                      key="campaignEventGoalSelectAnswerBlank"
                      value="blank"
                    >
                      Select an answer
                    </MenuItem>,
                    ...(customFormQuestion?.(subIdx)?.field?.field_options?.map(
                      field_option => (
                        <MenuItem
                          key={`campaignEventGoalSelectAnswer${field_option}`}
                          value={field_option}
                        >
                          {field_option}
                        </MenuItem>
                      ),
                    ) || []),
                    ...[],
                  ]}
                />
              </div>
              {iconButton(subIdx)}
            </div>
          )
        }

        const entitySelectItemsOriginal = [
          <MenuItem key={`campaignEventGoalSelectOptionblank`} value="blank">
            {`Select a ${
              entityTypeColloquialMap?.[
                this.props.eventgoaloptions?.[this.props.newEventGoal?.id]
                  ?.entity_id_type
              ]
            }`}
          </MenuItem>,
          <Divider key={`campaignEventGoalSelectDivider`} />,
          campaignOptions?.length ? (
            <ListSubheader
              disableSticky
              value="blank"
              key={`campaignEventGoalSubheader`}
            >
              {`${capitalize(
                entityTypeColloquialMap?.[
                  this.props.eventgoaloptions?.[this.props.newEventGoal?.id]
                    ?.entity_id_type
                ],
              )}s in campaign`}
            </ListSubheader>
          ) : null,
          ...(campaignOptions || []),
          <Divider key={`campaignEventGoalSelectDivider2`} />,
          campaignOptions?.length ? (
            <ListSubheader
              disableSticky
              value="blank"
              key="campaignEventGoalSubheader2"
            >
              Others
            </ListSubheader>
          ) : null,
          ...(restOptions || []),
        ]

        const entitySelectItemsDup = entitySelectItemsOriginal.slice()
        entitySelectItemsDup.splice(
          1,
          0,
          <MenuItem key="createGroupModal" value="createGroupModal">
            Create a new group
          </MenuItem>,
        )

        const entitySelectItems =
          this.props.eventgoaloptions?.[this.props.newEventGoal?.id]
            ?.entity_id_type === 'contactgroup'
            ? entitySelectItemsDup
            : entitySelectItemsOriginal

        const subentitySelect = subIdx => {
          if (
            !this.props.entityIDSelected &&
            this.props.newEventGoal.id !== '14' &&
            this.props.newEventGoal.id !== '15'
          ) {
            return null
          }

          const width = iconButtonFunc(subIdx, 'calc(100% - 50px)', '100%')
          const marginTop = iconButtonFunc(subIdx, 18, 10)

          const isCustomField =
            typeof subIdx === 'number'
              ? this.props.subcriteria?.[subIdx]?.isCustomField
              : this.props.isCustomField

          const customFieldName =
            typeof subIdx === 'number'
              ? this.props.subcriteria?.[subIdx]?.customFieldName
              : this.props.customFieldName

          return this.props.newEventGoal.subentity_id_type &&
            this.props.newEventGoal.event_type !==
              'event.sms.twilio.inbound' ? (
            <div
              style={
                this.props.newEventGoal.subentity_value
                  ? { marginBottom: 10 }
                  : this.props.newEventGoal.id === '12'
                  ? { position: 'relative', marginTop }
                  : {}
              }
            >
              <div style={this.props.newEventGoal.id === '12' ? { width } : {}}>
                <EntitySelect
                  value={
                    isCustomField
                      ? 'custom'
                      : typeof subIdx === 'number'
                      ? this.props.subcriteria?.[subIdx]?.subentity || 'blank'
                      : this.props.subentity || 'blank'
                  }
                  handleChange={field_name => {
                    if (field_name === 'custom') {
                      this.props.changeCustomField(
                        {
                          isCustomField: true,
                          customFieldName: '',
                        },
                        subIdx,
                      )
                    } else if (field_name !== 'blank') {
                      if (
                        !this.props.newEventGoal.subentity_value &&
                        this.props.newEventGoal.id !== '12'
                      ) {
                        Promise.resolve(
                          this.props.addEventGoalToCampaign({
                            event_goal: {
                              event_type:
                                this.props.eventgoaloptions[
                                  this.props.newEventGoal.id
                                ].event_type,
                              entity: this.props.entityIDSelected,
                              subentity: field_name,
                            },
                            index: this.props.stageIdx,
                            editIdx: this.props.newEventGoal.editIdx,
                          }),
                        ).then(() => this.props.createOrUpdateCampaign())
                      } else {
                        this.props.changeCustomField(
                          {
                            isCustomField: false,
                            customFieldName: '',
                          },
                          subIdx,
                        )
                        this.props.changeSubentity(
                          field_name,
                          subIdx,
                          // this logic should change when we add numeric contact values
                          this.props.newEventGoal.id === '13'
                            ? customFormQuestion(null, field_name)
                            : undefined,
                        )
                      }
                    }
                  }}
                  items={[
                    <MenuItem
                      key="campaignEventGoalSelectQuestionBlank"
                      value="blank"
                    >
                      {`Select a ${
                        this.props.newEventGoal.event_type ===
                        'event.custom.submit.contact'
                          ? 'question'
                          : 'contact attribute'
                      }`}
                    </MenuItem>,
                    <MenuItem
                      key="campaignEventGoalSelectQuestionCustom"
                      value="custom"
                    >
                      Add custom field
                    </MenuItem>,
                    ...(subentityOptions || []),
                  ]}
                />
              </div>
              {isCustomField && (
                <div style={{ marginTop: 10 }}>
                  <input
                    placeholder="Enter custom field name (letters, numbers, and underscores only)"
                    value={customFieldName}
                    onChange={e => {
                      const value = e.target.value.replace(/[^a-zA-Z0-9_]/g, '')
                      this.props.changeCustomField(
                        {
                          isCustomField: true,
                          customFieldName: value,
                        },
                        subIdx,
                      )
                    }}
                    style={{
                      width: '100%',
                      fontSize: 16,
                      padding: '5px 5px 5px 14px',
                      borderRadius: 24,
                    }}
                    className={this.props.classes.input}
                  />
                </div>
              )}
              {this.props.newEventGoal.id === '12' && iconButton(subIdx)}
            </div>
          ) : null
        }

        const addSubcriteriaVisible = () => {
          if (this.props.newEventGoal.subentity_id_type) {
            if (this.props.newEventGoal.id === '12' && this.props.subentity)
              return true
            if (this.props.subentity_value) return true
          }

          return false
        }

        const createdEventGoal = (event_goal, idx) => (
          <Fragment key={`event_goalCampaignPage${idx}${this.props.stageIdx}`}>
            <div className={this.props.classes.eventGoal}>
              <EntityTypeIcon
                entityType="eventgoaloption"
                entityID={event_goal.event_type}
                className={this.props.classes.entityTypeIcon}
              />
              <div className={this.props.classes.name}>
                {description(event_goal)}
                {event_goal?.and_subcriteria?.length > 1
                  ? event_goal.and_subcriteria
                      .slice(1)
                      .map((subcriteria, idx) => {
                        return (
                          <Fragment
                            key={`subcriteriaDescription${this.props.stageIdx}-${idx}`}
                          >
                            <div
                              style={{
                                textAlign: 'center',
                                fontWeight: 'bold',
                                margin: '7px 0',
                              }}
                            >
                              AND
                            </div>
                            {description({
                              ...event_goal,
                              subentity: subcriteria?.subentity,
                              subentity_value: subcriteria?.subentity_value,
                              operator: subcriteria?.operator,
                            })}
                          </Fragment>
                        )
                      })
                  : null}
                {event_goal.count ? (
                  <div className={this.props.classes.stat}>
                    <span className={this.props.classes.number}>
                      {formatNumber(event_goal.count)}
                    </span>
                    <div className={this.props.classes.text}>
                      <div>Total</div>
                      <div>Contacts</div>
                    </div>
                  </div>
                ) : null}
              </div>
              <IconButton
                disabled={
                  this.props.status === 'L' || this.props.status === 'C'
                }
                style={{
                  position: 'absolute',
                  right: 4,
                  top: 4,
                }}
                aria-owns={
                  this.state.anchorEl
                    ? `stageMenu${this.props.stageIdx}eventGoal${event_goal.id}`
                    : undefined
                }
                aria-haspopup="true"
                onClick={e => {
                  e.stopPropagation()
                  this.setState({
                    anchorEl: e.currentTarget,
                    menuIdx: idx,
                  })
                }}
                disableRipple
                disableTouchRipple
              >
                <MoreVert />
              </IconButton>
              <Menu
                id={`stageMenu${this.props.stageIdx}eventGoal${
                  event_goal.id || idx
                }`}
                anchorEl={this.state.anchorEl}
                open={
                  Boolean(this.state.anchorEl) && this.state.menuIdx === idx
                }
                onClose={e => {
                  e.stopPropagation()
                  this.setState({ anchorEl: null, menuIdx: null })
                }}
              >
                <MenuItem
                  onClick={e => {
                    e.stopPropagation()
                    this.setState({ anchorEl: null, menuIdx: null })
                    this.props.addOrEditEventGoal({
                      event_type: event_goal.event_type,
                      stage: this.props.stageIdx,
                      editIdx: idx,
                      event_goal,
                      ...trueEventOptionFunc(
                        event_goal,
                        this.props.eventgoaloptions,
                      ),
                    })
                  }}
                >
                  <ListItemIcon className={this.props.classes.icon}>
                    <Edit />
                  </ListItemIcon>
                  <ListItemText
                    classes={{
                      primary: this.props.classes.primary,
                      root: this.props.classes.listItemTextRoot,
                    }}
                    primary="Edit event goal"
                  />
                </MenuItem>
                <MenuItem
                  onClick={e => {
                    e.stopPropagation()
                    this.setState({ anchorEl: null, menuIdx: null })
                    Promise.resolve(
                      this.props.removeEventGoal(this.props.stageIdx, idx),
                    ).then(() => this.props.createOrUpdateCampaign())
                  }}
                >
                  <ListItemIcon className={this.props.classes.icon}>
                    <Delete />
                  </ListItemIcon>
                  <ListItemText
                    classes={{
                      primary: this.props.classes.primary,
                      root: this.props.classes.listItemTextRoot,
                    }}
                    primary={`${language.campaign.add.removeEventGoal}`}
                  />
                </MenuItem>
              </Menu>
            </div>
            {(this.props.event_goals.length > 1 &&
              idx !== this.props.event_goals.length - 1) ||
            (idx === this.props.event_goals.length - 1 &&
              this.props.newEventGoal.event_type) ? (
              <div
                style={{
                  textAlign: 'center',
                  fontWeight: 'bold',
                  color: '#497647',
                }}
              >
                OR
              </div>
            ) : null}
          </Fragment>
        )

        const newEventGoal = eventGoalIdx => (
          <div
            key={`newEventGoal${this.props.stageIdx}${this.props.eventGoalIdx}`}
            className={this.props.classes.eventGoal}
          >
            <div
              style={{
                margin: '5px 0px 0px -45px',
              }}
            >
              <div style={{ marginBottom: 10 }}>
                <EventGoalSelect
                  items={[
                    <MenuItem
                      key={`campaignEventGoalSelectOptionblank`}
                      value="blank"
                    >
                      Select an Event Goal
                    </MenuItem>,
                    ...Object.values(this.props.eventgoaloptions || {})
                      // remove this filter
                      .filter(
                        option =>
                          parseInt(option.id) <=
                          currentNumberOfAllowedEventGoals,
                      )
                      .map(eventgoaloption => {
                        const Icon = entityTypeIconMap(
                          'eventgoaloptions',
                          eventgoaloption.id,
                        )

                        return (
                          <MenuItem
                            key={`campaignEventGoalSelectOption${eventgoaloption.id}`}
                            value={eventgoaloption.id}
                          >
                            <ListItemIcon
                              classes={{
                                root: this.props.classes.listItemIconRoot,
                              }}
                            >
                              <Icon />
                            </ListItemIcon>
                            {eventgoaloption.short_description}
                          </MenuItem>
                        )
                      }),
                  ]}
                  handleChange={event_type_id => {
                    const eventgoaloption =
                      this.props.eventgoaloptions[event_type_id]

                    ;(eventgoaloption.entity_id_type &&
                      eventgoaloption.entity_id_type !== '"-1"') ||
                    eventgoaloption.subentity_id_type ||
                    eventgoaloption.subentity_value
                      ? this.props.addOrEditEventGoal({
                          editIdx: this.props.newEventGoal.editIdx,
                          stage: this.props.stageIdx,
                          // editIdx: eventGoalIdx,
                          ...eventgoaloption,
                        })
                      : Promise.resolve(
                          this.props.addEventGoalToCampaign({
                            event_goal: {
                              event_type: eventgoaloption.event_type,
                              entity: '0',
                            },
                            index: this.props.stageIdx,
                            editIdx: this.props.newEventGoal.editIdx,
                          }),
                        ).then(() => this.props.createOrUpdateCampaign())
                  }}
                />
              </div>
              <div>
                {this.props.newEventGoal.event_type !== 'blank' &&
                this.props.newEventGoal.entity_id_type &&
                this.props.newEventGoal.entity_id_type !== '"-1"' ? (
                  <div style={{ marginBottom: 10 }}>
                    <EntitySelect
                      value={this.props.entityIDSelected || 'blank'}
                      items={entitySelectItems}
                      handleChange={id => {
                        if (
                          id !== 'blank' &&
                          id !== 'createGroupModal' &&
                          this.props.newEventGoal.id !== '12' &&
                          this.props.newEventGoal.id !== '13' &&
                          this.props.newEventGoal.id !== '18'
                        ) {
                          Promise.resolve(
                            this.props.addEventGoalToCampaign({
                              event_goal: {
                                event_type:
                                  this.props.eventgoaloptions[
                                    this.props.newEventGoal.id
                                  ].event_type,
                                entity: id,
                              },
                              index: this.props.stageIdx,
                              editIdx: this.props.newEventGoal.editIdx,
                            }),
                          ).then(() => this.props.createOrUpdateCampaign())
                        }

                        if (id === 'createGroupModal') {
                          this.props.toggleGroupDialog()
                        }

                        if (
                          this.props.newEventGoal.id === '12' ||
                          this.props.newEventGoal.id === '13'
                        ) {
                          this.props.read(id, 'customform')

                          this.props.selectEventGoal({
                            type: 'customform',
                            id,
                          })
                        }

                        if (this.props.newEventGoal.id === '18') {
                          this.props.changeEntity(id)
                        }
                      }}
                    />
                  </div>
                ) : null}
                {subentitySelect()}
                {this.props.newEventGoal.subentity_value ? (
                  this.props.subcriteria.length ? (
                    <>
                      {subentityValueComponent()}
                      {this.props.subcriteria.map((el, idx) => (
                        <Fragment key={`subCriteriaFragment${idx}`}>
                          <div
                            style={{
                              textAlign: 'center',
                              fontWeight: 'bold',
                              color: '#497647',
                              marginBottom: 10,
                              marginTop: 10,
                            }}
                          >
                            AND
                          </div>
                          <div style={{ position: 'relative' }}>
                            {subentitySelect(idx)}
                            {subentityValueComponent(idx)}
                            {removeSubcriteriaButton(idx)}
                          </div>
                        </Fragment>
                      ))}
                    </>
                  ) : (
                    subentityValueComponent()
                  )
                ) : this.props.newEventGoal.subentity_id_type &&
                  this.props.subcriteria.length ? (
                  this.props.subcriteria.map((el, idx) => {
                    return (
                      <Fragment key={`subCriteriaFragment${idx}`}>
                        <div
                          style={{
                            textAlign: 'center',
                            fontWeight: 'bold',
                            color: '#497647',
                            marginBottom: 10,
                            marginTop: 10,
                          }}
                        >
                          AND
                        </div>
                        <div style={{ position: 'relative' }}>
                          {subentitySelect(idx)}
                          {removeSubcriteriaButton(idx)}
                        </div>
                      </Fragment>
                    )
                  })
                ) : null}
                {addSubcriteriaVisible() && (
                  <div style={{ marginTop: 10, textAlign: 'center' }}>
                    <Button
                      variant="outlined"
                      onClick={() => this.props.addSubcriteria()}
                    >
                      <Add
                        style={{
                          marginRight: 5,
                        }}
                        className={this.props.classes?.addIcon}
                      />
                      Add subcriteria
                    </Button>
                  </div>
                )}
              </div>
            </div>
            <IconButton
              disabled={this.props.status === 'L' || this.props.status === 'C'}
              style={{
                position: 'absolute',
                right: 4,
                top: 4,
              }}
              aria-owns={
                this.state.anchorElNew
                  ? `stageMenu${this.props.stageIdx}newEventGoal`
                  : undefined
              }
              aria-haspopup="true"
              onClick={e => {
                e.stopPropagation()
                this.setState({ anchorElNew: e.currentTarget })
              }}
              disableRipple
              disableTouchRipple
            >
              <MoreVert />
            </IconButton>
            <Menu
              id={`stageMenu${this.props.stageIdx}newEventGoal`}
              anchorEl={this.state.anchorElNew}
              open={Boolean(this.state.anchorElNew)}
              onClose={e => {
                e.stopPropagation()
                this.setState({ anchorElNew: null })
              }}
            >
              <MenuItem
                onClick={e => {
                  e.stopPropagation()
                  this.setState({ anchorElNew: null })
                  this.props.removeNewEventGoal()
                }}
              >
                <ListItemIcon className={this.props.classes.icon}>
                  <Cancel />
                </ListItemIcon>
                <ListItemText
                  classes={{
                    primary: this.props.classes.primary,
                    root: this.props.classes.listItemTextRoot,
                  }}
                  primary="Cancel"
                />
              </MenuItem>
            </Menu>
          </div>
        )

        return (
          <div
            style={{
              padding: 15,
              position: 'relative',
            }}
          >
            <div
              style={{
                fontSize: 15,
                fontWeight: 'bold',
                paddingLeft: 16,
                marginBottom: 15,
              }}
            >
              {language.campaign.add.eventGoalsHeading}
            </div>
            <Button
              onClick={e => this.setState({ anchorElAdd: e?.currentTarget })}
              aria-owns={
                this.state.anchorElAdd
                  ? `add-event-goal-popup-menu-${this.props.stageIdx}`
                  : undefined
              }
              aria-haspopup
              color="secondary"
              className={this.props.classes.addButton}
              size="small"
              disabled={
                this.props.newEventGoal.stage === this.props.stageIdx ||
                this.props.status === 'L' ||
                this.props.status === 'C'
              }
            >
              <Add
                style={{
                  marginRight: 5,
                }}
                className={this.props.classes?.addIcon}
              />
              {language?.campaign?.add?.addEventGoalsButton}
            </Button>
            <Menu
              id="simple-menu"
              anchorEl={this.state?.anchorElAdd}
              open={Boolean(this.state.anchorElAdd)}
              onClose={() => this.setState({ anchorElAdd: null })}
            >
              {Object.values(this.props.eventgoaloptions || {})
                .filter(
                  option =>
                    parseInt(option.id) <= currentNumberOfAllowedEventGoals,
                )
                .map(eventgoaloption => {
                  const Icon = entityTypeIconMap(
                    'eventgoaloptions',
                    eventgoaloption.id,
                  )

                  return (
                    <MenuItem
                      key={`campaignEventGoalSelectOption${eventgoaloption.id}`}
                      value={eventgoaloption.id}
                      onClick={() => {
                        this.setState({ anchorElAdd: null })
                        ;(eventgoaloption.entity_id_type &&
                          eventgoaloption.entity_id_type !== '"-1"') ||
                        eventgoaloption.subentity_id_type ||
                        eventgoaloption.subentity_value
                          ? this.props.addOrEditEventGoal({
                              stage: this.props.stageIdx,
                              ...eventgoaloption,
                            })
                          : Promise.resolve(
                              this.props.addEventGoalToCampaign({
                                event_goal: {
                                  event_type: eventgoaloption.event_type,
                                  entity: '0',
                                },
                                index: this.props.stageIdx,
                                editIdx: this.props.newEventGoal.editIdx,
                              }),
                            ).then(() => this.props.createOrUpdateCampaign())
                      }}
                    >
                      <ListItemIcon
                        classes={{
                          root: this.props.classes.listItemIconRoot,
                        }}
                      >
                        <Icon />
                      </ListItemIcon>
                      {eventgoaloption.short_description}
                    </MenuItem>
                  )
                })}
            </Menu>
            {this.props.event_goals && this.props.event_goals.length
              ? this.props.event_goals.map((event_goal, idx) =>
                  (this.props.newEventGoal.stage === this.props.stageIdx &&
                    this.props.newEventGoal.editIdx) === idx
                    ? newEventGoal(idx)
                    : createdEventGoal(event_goal, idx),
                )
              : null}
            {this.props.newEventGoal.stage === this.props.stageIdx &&
            !this.props.newEventGoal.editIdx &&
            typeof this.props.newEventGoal.editIdx !== 'number'
              ? newEventGoal()
              : null}
          </div>
        )
      }
    },
  ),
)
